import { useEffect, useState } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { appelApi } from './api';

export type RubriqueRecherche = 'apprenants' | 'organisations' | 'documents';

export interface ResultatRecherche {
  id: string;
  libelle: string;
  detail: string | null;
  /** Chemin de la SPA où mène le résultat, décidé par l'API selon le profil. */
  lien: string;
}

export interface ReponseRecherche {
  terme: string;
  rubriques: { rubrique: RubriqueRecherche; resultats: ResultatRecherche[] }[];
}

/** Même seuil que l'API : en deçà, la requête n'est pas envoyée. */
export const LONGUEUR_MIN_RECHERCHE = 2;

/** Laisse la frappe se terminer avant d'interroger l'API. */
export function useValeurDifferee(valeur: string, delai: number): string {
  const [differee, setDifferee] = useState(valeur);
  useEffect(() => {
    const minuterie = window.setTimeout(() => setDifferee(valeur), delai);
    return () => window.clearTimeout(minuterie);
  }, [valeur, delai]);
  return differee;
}

export function useRecherche(saisie: string) {
  const terme = useValeurDifferee(saisie.trim(), 250);
  const active = terme.length >= LONGUEUR_MIN_RECHERCHE;

  const requete = useQuery({
    queryKey: ['recherche', terme],
    queryFn: () => appelApi<ReponseRecherche>(`/recherche?${new URLSearchParams({ q: terme }).toString()}`),
    enabled: active,
    staleTime: 30 * 1000,
    placeholderData: keepPreviousData,
  });

  return {
    ...requete,
    active,
    /** Vrai tant que la saisie n'a pas encore été envoyée ou que la réponse n'est pas revenue. */
    enAttente: saisie.trim() !== terme || requete.isFetching,
  };
}
